export default __webpack_public_path__ + "static/IBMPlexSans-Italic-Latin1-b02a06390388409ab8cd4a9aa0eeef1d.woff";